"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useStatusSelectedItems = function (allSelectedItems, listItems) {
    var listItemMap = (0, react_1.useMemo)(function () { return (listItems.reduce(function (acc, listItem) {
        acc[listItem.key] = true;
        return acc;
    }, {})); }, [listItems]);
    var matchesAmount = (0, react_1.useMemo)(function () { return (allSelectedItems.reduce(function (acc, selectedItem) {
        if (listItemMap[selectedItem.key])
            return acc + 1;
        return acc;
    }, 0)); }, [allSelectedItems, listItemMap]);
    var selectedItemsAmount = (0, react_1.useMemo)(function () { return allSelectedItems.length; }, [allSelectedItems]);
    var listItemsAmount = (0, react_1.useMemo)(function () { return listItems.length; }, [listItems]);
    var statusSelectedItems = (0, react_1.useMemo)(function () { return ({
        notSelected: matchesAmount === 0,
        partSelected: matchesAmount !== 0 && matchesAmount !== listItemsAmount,
        allSelected: selectedItemsAmount === listItemsAmount
    }); }, [selectedItemsAmount, listItemsAmount, matchesAmount]);
    return statusSelectedItems;
};
exports.default = useStatusSelectedItems;
